import http from "./http";

function addAssignDriver(data) {
  return http.post(`VehicleAssign`, data);
}

function updateAssignDriver(data) {
  return http.post(`UpdateVehicleAssign`, data);
}

function getAssignedDriver(data) {
  return http.post(`vehicleAssignList`, data);
}

function deleteassignDriver(data) {
  return http.post(`Delete_AssignVehicle`, data);
}

const AssignDriver_VehicleService = {
  addAssignDriver,
  updateAssignDriver,
  getAssignedDriver,
  deleteassignDriver,
};

export default AssignDriver_VehicleService;
